import React, { Component } from 'react'
import PropTypes from 'prop-types'

class ParameterTable extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    parameters: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired,
  }

  renderRows = (parameter, index) => {
    const { openModal } = this.props

    return (
      <tr key={index}>
        <td className='align-left'>{parameter.idBranch}</td>
        <td className='align-left'>{parameter.dsKey}</td>
        <td className='align-left'>{parameter.nuParameter}</td>
        <td className='align-left line-break-parameter'>{parameter.dsValue}</td>
        <td className='align-center'>
          <a
            id={`view-parameter-${index}`}
            className='margin-right'
            role='button'
            onClick={() => openModal(index, true)}
          >
            <i className='glyph glyph-eye icon-size' />
          </a>

          <a
            id={`edit-parameter-${index}`}
            role='button'
            onClick={() => openModal(index, false)}
          >
            <i className='glyph glyph-pencil icon-size' />
          </a>
        </td>
      </tr>
    )
  }

  render() {
    const { parameters, translate } = this.props

    return (
      <div>
        <legend className='margin-top-double margin-bottom'>
          {translate('parameters.list-parameters')}
        </legend>

        <table className='table table-zebra'>
          <thead>
            <tr>
              <th className='align-left'>{translate('parameters.idBranch')}</th>
              <th className='align-left'>{translate('parameters.dsKey')}</th>
              <th className='align-left'>
                {translate('parameters.nuParameter')}
              </th>
              <th className='align-left line-break-parameter'>
                {translate('parameters.dsValue')}
              </th>
              <th className='align-center'>{translate('actions')}</th>
            </tr>
          </thead>
          <tbody>{parameters.map(this.renderRows)}</tbody>
        </table>
      </div>
    )
  }
}

export default ParameterTable
